<template>
    <div id="module_create">
        <div :class="`loader${loaderClass}`" v-show="loading">

        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="container-fluid xyz">
                <div class="page-name">
                    <span id="moduleHeader">Add Module</span>
                    <button type="submit" class="btn btn-success waves-effect pull-right" v-on:click.prevent="BackModuleList">
                            Back
                    </button>
                </div>
                <div class="admin-page-content">
                    <section class="internal-container">
                        <div class="container">
                            <form autocomplete="off" class="form-horizontal" id="ModuleForm">

                                <div class="form-group">
                                    <label class="control-label col-sm-2" for="name">Name:</label>
                                    <div class="col-sm-6">
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Module Name" name="name">
                                        <div class="c-error">{{name_error_msg}}</div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-offset-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>

                                <!-- <div class="form-group"> -->
                                <div class="col-sm-offset-5 col-sm-6">
                                    <input type="submit" id="cancelModuleBtn" value="Cancel" class="btn btn-primary nextBtn btn-lg pull-right" v-on:click.prevent="BackModuleList">
                                    <input type="submit" id="createAndContinueModuleBtn" value="Save and Continue" class="btn btn-primary nextBtn btn-lg pull-right" v-on:click.prevent="CreateModule(flag='Save and Continue')">
                                    <input type="submit" id="createModuleBtn" value="Save" class="btn btn-primary nextBtn btn-lg pull-right" v-on:click.prevent="CreateModule">
                                </div>
                                <!-- </div> -->

                            </form>
                        </div>
                    </section>
                </div>
            </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';


export default {
  name: "ModuleCreate",

  mixins:[commonMixins],
  data: () => ({
         permissions: [],
        cantAccessPage: "",
        name: "",
        loading:false,
        name_error_msg: ""
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_module') {
                        alert("in")
                        self.cantAccessPage = true;

                        setTimeout(function () {
                            var path = window.location.pathname;
                            var segments = path.split("/");

                            if (segments[3]) {
                                $("#createModuleBtn").val("Update");
                                $("#moduleHeader").text("Edit Module");
                                $("#createAndContinueModuleBtn").hide();
                                self.loadModule();
                            }
                        }, 100);
                    }
                }
            }

        }
  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
  },
  methods: {

    BackModuleList() {
      var self = this;
      self.$router.push("/modules/list");
    },

    CreateModule(flag) {
      var self = this;

      self.name_error_msg = "";

      if (!self.name || self.name == null || self.name == "") {
        self.name_error_msg = "Name Required.";
      }

      if (self.name_error_msg == "") {

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createModuleBtn").val("Updating ...");
                $("#createModuleBtn").prop("disabled", true);
                $("#cancelModuleBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueModuleBtn").val("Saving ...");
                    $("#createModuleBtn").prop("disabled", true);
                    $("#createAndContinueModuleBtn").prop("disabled", true);
                    $("#cancelModuleBtn").prop("disabled",true);

                }else{

                    $("#createModuleBtn").val("Saving ...");
                    $("#createModuleBtn").prop("disabled", true);
                    $("#createAndContinueModuleBtn").prop("disabled", true);
                    $("#cancelModuleBtn").prop("disabled",true);
                }

            }

            $.ajax({
                url: process.env.ROOT_API + "/modules/create",
                type: "POST",
                data: {name: self.name, id: segments[3]},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createModuleBtn").val("Update");
                        $("#createModuleBtn").prop("disabled", false);
                        $("#cancelModuleBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueModuleBtn").val("Save and Continue");
                            $("#createModuleBtn").prop("disabled", false);
                            $("#createAndContinueModuleBtn").prop("disabled", false);
                            $("#cancelModuleBtn").prop("disabled",false);

                        }else{

                            $("#createModuleBtn").val("Save");
                            $("#createModuleBtn").prop("disabled", false);
                            $("#createAndContinueModuleBtn").prop("disabled", false);
                            $("#cancelModuleBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            // $("#ModuleForm").trigger("reset");
                            self.name = "";

                        }else{
                            self.$router.push("/modules/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                     if (segments[3])
                    {
                        $("#createModuleBtn").val("Update");
                        $("#createModuleBtn").prop("disabled", false);
                        $("#cancelModuleBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            // $("#ModuleForm").trigger("reset");
                            self.name = "";
                            $("#createAndContinueModuleBtn").val("Save and Continue");
                            $("#createModuleBtn").prop("disabled", false);
                            $("#createAndContinueModuleBtn").prop("disabled", false);
                            $("#cancelModuleBtn").prop("disabled",false);

                        }else{

                            $("#createModuleBtn").val("Save");
                            $("#createModuleBtn").prop("disabled", false);
                            $("#createAndContinueModuleBtn").prop("disabled", false);
                            $("#cancelModuleBtn").prop("disabled",false);

                        }
                    }
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server cannot be reached";
                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");
                            self.$router.push("/");
                        }
                        $("#errorMsg").html(jqXHR.responseJSON.message);
                        $(".alert-warning").toggleClass("show");
                        setTimeout(function () {
                            $(".alert-warning").removeClass("show");
                            $(".alert-warning").addClass("hide");
                        }, 10000);
                    }
                }
            });

      }

    },

    loadModule() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/modules/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.name = data.content.name;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");
                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ModulesCreate.vue